import React from "react";
import { css } from "@emotion/css";

export const RCBillingBanner: React.FC = () => (
  <div className={rcBillingBannerStyle}>
    <div className={rcBillingIconStyle}>📧</div>
    <div className={rcBillingContentStyle}>
      <h3 className={rcBillingTitleStyle}>Manage Your Subscription via Email</h3>
      <p className={rcBillingMessageStyle}>
        Click the link in the email from RevenueCat to update or cancel your subscription.<br />
        If you have any questions, contact Wand Technologies at <a href="mailto:info@wand.tech">info@wand.tech</a> or reply directly to the email.
      </p>
    </div>
  </div>
);

const rcBillingBannerStyle = css`
  background: rgba(15, 125, 255, 0.08);
  border: 1px solid rgba(15, 125, 255, 0.2);
  border-radius: 12px;
  margin-bottom: 20px;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
`;

const rcBillingIconStyle = css`
  font-size: 32px;
  line-height: 1;
  margin-top: 4px;
  margin-right: 16px;
`;

const rcBillingContentStyle = css`
  flex: 1;
`;

const rcBillingTitleStyle = css`
  font-size: 18px;
  font-weight: 600;
  color: #0f7dff;
  margin: 0 0 8px 0;
`;

const rcBillingMessageStyle = css`
  font-size: 14px;
  color: #ffffff;
  line-height: 1.5;
  margin: 0;
  opacity: 0.9;
  a {
    color: #0f7dff;
    text-decoration: underline;
  }
`;
